<template>
    <div class="data-table w-100">
        <div class="table-responsive">
            <table class="table mb-0">
                <thead>
                    <tr>
                        <th>Fecha</th>
                        <th>#</th>
                        <th>Cliente</th>
                        <th class="text-right">Monto facturas</th>
                        <th class="text-right">Monto pagos</th>
                        <th class="text-right">Total imputado</th>
                        <th>Pago de origen</th>
                        <th class="text-right">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(loc, index) in allocationsList" :key="index">
                        <td>{{ formatDate(loc.created_at) }}</td>
                        <td>{{ loc.id }}</td>
                        <td>{{ loc.client_name }}</td>
                        <td class="text-right">$ {{ parseFloat(loc.debit).toFixed(2) }}</td>
                        <td class="text-right">$ {{ parseFloat(loc.credit).toFixed(2) }}</td>
                        <td class="text-right"><span class="data-table__primary">$ {{ parseFloat(loc.saleAllocation).toFixed(2) }}</span></td>
                        <td>
                            <span v-if="loc.origin_receipt != null">RC {{ loc.origin.pos }}-{{ loc.origin.number }}</span>
                            <span v-else class="data-table__muted">-</span>
                        </td>
                        <td class="text-right">
                            <div class="table-action-group">
                                <a class="table-action-btn" :href="'/ventas/cobranzas/detalle-imputacion/' + loc.id" title="Ver detalle">
                                    <i class="bi bi-eye"></i>
                                </a>
                                <button type="button" class="table-action-btn" title="Desimputar" @click="deleteAllocation(loc.id)">
                                    <i class="bi bi-x-circle"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="allocationsList.length === 0">
                        <td colspan="8" class="data-table__empty">Sin imputaciones para mostrar</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- PAGINACION -->
        <div class="data-table__footer">
            <div class="data-table__info">
                Página {{ page }} de {{ totalPages }}
            </div>
            <ul class="data-table__pagination">
                <li class="page-item" :class="{ disabled: page === 1 }">
                    <a class="page-link" href="#" @click.prevent="prevPage()"><i class="bi bi-chevron-left"></i></a>
                </li>
                <li v-if="(page - (pageInterval / 2)) > 0" class="page-item">
                    <a class="page-link" href="#" @click.prevent="prevPage()">…</a>
                </li>
                <template v-for="index in totalPages">
                    <li v-if="inIntervalPage(index)" :key="index" class="page-item" :class="{ active: page === index }">
                        <a class="page-link" href="#" @click.prevent="changePage(index)">{{ index }}</a>
                    </li>
                </template>
                <li v-if="totalPages > (page + (pageInterval / 2))" class="page-item">
                    <a class="page-link" href="#" @click.prevent="nextPage()">…</a>
                </li>
                <li class="page-item" :class="{ disabled: page >= totalPages }">
                    <a class="page-link" href="#" @click.prevent="nextPage()"><i class="bi bi-chevron-right"></i></a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

import moment from 'moment';

export default {
    props: ['client','fromDate','toDate'],
    data() {
        return {
            allocationsList:[],
            page:1,
            rowCount:9,
            totalItems:0,
            totalPages:1,
            pageInterval:22,
        }
    },
    mounted(){
        this.getAllocations();
    },
    methods: {
        getAllocations(){
            var vm= this;
            var outdata = {
                'client': vm.client,
                'fromDate':vm.fromDate,
                'toDate':vm.toDate,
                'page':vm.page,
                'rowCount':vm.rowCount
            };
            this.$http.post('/api/collections/getAllocations', outdata)
            .then(response => {
                if(response.data) {
                vm.allocationsList = response.data.data.list;
                vm.totalItems=response.data.data.totalItems;
              }
            })
            .catch(error => {
              alert(error);
            })
        },
        deleteAllocation(id){
            if (confirm("Esta operación es irreversible, todos los comprobantes volverán al estado anterior de la imputación. ¿Desea continuar?")){
                this.$http.get('/api/collections/deleteAllocation/'+id)
                .then(response => {
                if(response.data.success) {
                    this.getAllocations();
                    this.$emit('allocationDeleted');
                }else{
                  // no-op intencional
                  
                }
            })
            .catch(error => {
              alert(error);
            })
            }
        },
        formatDate(value){
            if (value){
                return moment(String(value)).format('DD/MM/YYYY');
            }
        },
        prevPage(){
            this.page = this.page-1;
            this.getAllocations();
        },
        nextPage(){
            this.page = this.page +1;
            this.getAllocations();
        },
        changePage(data){
            this.page = data;
            this.getAllocations();
        },
        inIntervalPage(index){
            if(this.totalPages<=this.pageInterval){return true;}

            let limitprev = this.page - (this.pageInterval/2);
            let limitnext = this.page + (this.pageInterval/2);

            if(limitprev<0){
                limitprev=0;
                limitnext=this.pageInterval;
            }

            if(index>limitprev && index<limitnext){
                return true;
            }

            return false;
        },
    },
    watch: {
      'client': {
          handler: function () {
              this.page=1;
              this.getAllocations();
            }
      },
      'fromDate': {
          handler: function () {this.getAllocations();}
      },
      'toDate': {
          handler: function () {this.getAllocations();}
      },
      'allocationsList':{
          handler: function(){
              this.totalPages = Math.ceil(this.totalItems / this.rowCount);
          }
      }
  },

}
</script>
